<script setup lang="ts">
import UIBrow from '@/components/ui/UIBrow.vue'
import { computed } from 'vue'

const props = withDefaults(
  defineProps<{
    /** What text should be displayed? */
    text?: string
    /** How large should the text be? */
    size?: 'default' | 'sm'
    /** How should the pill be colored (raw hex colors)? */
    rawColors?: {
      bgColor: string
      textColor: string
    }
    /** How should the pill be colored (tailwind classes)? */
    twColors?: {
      bgColorClass: string
      borderColorClass?: string
      textColorClass?: string
    }
  }>(),
  {
    size: 'default'
  }
)

const charcoalTextBackgrounds = [
  'bg-fire-tint-1',
  'bg-poppy',
  'bg-sprout-tint-1',
  'bg-sage-tint-1',
  'bg-elevated'
]

const textColorClasses = computed(() => {
  if (props.twColors) {
    if (props.twColors.textColorClass) {
      return props.twColors.textColorClass
    } else if (
      props.twColors.bgColorClass &&
      charcoalTextBackgrounds.includes(props.twColors.bgColorClass)
    ) {
      return 'text-emphasis'
    } else if (
      props.twColors.bgColorClass === 'bg-slate-tint-5' ||
      props.twColors.bgColorClass.includes('transparent') ||
      props.twColors.bgColorClass === 'bg-elevated'
    ) {
      return 'text-default'
    }
    return 'text-inverse'
  }
  return ''
})

const bgColorClasses = computed(() => {
  if (props.twColors) {
    return props.twColors.bgColorClass
  }
  return ''
})

const borderClasses = computed(() => {
  if (props.twColors?.borderColorClass) {
    return `border border-solid ${props.twColors.borderColorClass}`
  }
  return ''
})

const styles = computed(() => {
  if (props.rawColors) {
    return {
      backgroundColor: props.rawColors.bgColor,
      color: props.rawColors.textColor
    }
  }
  return {}
})
</script>

<template>
  <div
    class="flex items-center py-1 px-3 space-x-1 rounded-[70px]"
    :class="[bgColorClasses, borderClasses, textColorClasses]"
    :style="styles"
  >
    <UIBrow
      :text="text"
      :size="size"
      class="text-ellipsis overflow-hidden whitespace-nowrap"
    >
      <slot></slot>
    </UIBrow>
    <slot name="icon-right"></slot>
  </div>
</template>
